import { CheckCreator } from 'lib/utils/formValidation/formValidation';
import isEmpty from 'lib/utils/formValidation/isEmpty';

/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
const matchesRegexp: CheckCreator = (regExp: RegExp) => (value: string) =>
  isEmpty(value) || regExp.test(value);

export default matchesRegexp;
